import React from 'react'

import { useDrop } from 'react-dnd'

import { func, number, node } from 'prop-types'

const ITEM_TYPE = 'PENDING_MEDIA'

function MediaDropZone({ index, onMove: handleMove, children }) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ITEM_TYPE,
    drop: (item) => {
      if (item.index !== index) {
        handleMove(item.index, index)
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    // eslint-disable-next-line no-unused-vars
    canDrop: (_item) => {
      // Always allow dropping, even on the same index (which will be ignored anyway)
      return true
    },
  })

  const isActive = isOver && canDrop

  return (
    <div
      ref={drop}
      className={`use-cases-area__drop-zone ${isActive ? 'active' : ''}`}
    >
      {children}
      {isActive && (
        <div className="use-cases-area__drop-indicator">
          Drop here to reorder
        </div>
      )}
    </div>
  )
}

MediaDropZone.propTypes = {
  index: number.isRequired,
  onMove: func.isRequired,
  children: node.isRequired,
}

export default MediaDropZone
